

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function WatchModel() {
    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    const [watchlist, setWatchlist] = useState([{
        WatchList_ID : 0,
        Ticker : "",
        name : '',
        User_ID : 0,
        UpdatedDate : {},
        lastSale : 0,
        netChange : 0,
        perChange : 0,
        CreatedDate : ""
    }])

    const [trendingStocks,setTrendingStocks] = useState([{
        symbol : "",
        name : "",
        lastSale : "",
        netChange : "",
        volume : 0,
        pctChange : "",
        perChange : "",
        marketCap : "",
        url : ""
    }])

    const viewWatchlist = async () =>{
        debugger;
        const responseData:any = await apiModel.watchlist();
        debugger;
        if (responseData.length > 0) {
            debugger;
            for(let i=0;i<responseData.length;i++){
                debugger;
                let data = trendingStocks.filter((x:any)=> x.symbol == responseData[i].Ticker);
                if(data.length > 0){
                    debugger;
                    responseData[i].name = data[0].name;
                    responseData[i].lastSale = data[0].lastSale;
                    responseData[i].netChange = data[0].netChange;
                    responseData[i].perChange = data[0].perChange;
                }
            }
            debugger;
            setWatchlist(responseData);
        }
    }


    const getStocks = async () =>{
        debugger;
        const responseData1:any = await apiModel.getTodayStocks();
        debugger;
        if (responseData1.length > 0) {
            debugger;
            setTrendingStocks(responseData1)
        }
    }

    const getLastPriceByTicker =  (symbol:any, columnName:any) :any=>{
        debugger;
        if(trendingStocks.length >=2 && symbol!='' && columnName !=''){
            debugger;
            let result:any = trendingStocks.filter(x => x.symbol == symbol);
            if(result.length > 0){
                return result[0][columnName];
            }else{
                return 0;
            }
            
        }
       
    } 

    const viewStockDetails = (d:any) =>{
        debugger;
        const queryParams = {
            ticker: d.Ticker,
        };
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/ticker-details?${queryString}`);
    }




    useEffect(()=>{ 
        viewWatchlist();
    },[trendingStocks]);

    useEffect(()=>{
        getStocks();
    },[alert]);


    return { watchlist , getLastPriceByTicker ,viewStockDetails}

}